import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import styles from './Modal.less';
import ModalWrapper from './Wrapper/Wrapper.jsx';

export const Modal = ({
  opened,
  closeHandler,
  title,
  subTitle,
  children,
  afterOpenHandler,
  className,
  contentClassName,
  titleWrapperClassName,
}) => (
  <ReactModal
    isOpen={opened}
    onRequestClose={closeHandler}
    onAfterOpen={afterOpenHandler}
    className={`modal-container ${styles.cosmaContainer} ${className}`}
    overlayClassName={`modal-backdrop ${styles.cosmaOverlay}`}
    appElement={window.document.body}
  >
    <button type="button" className="modal-close-button" aria-label="Schließen" onClick={closeHandler}>
      <span className="is24-icon-closing" />
    </button>

    {title ? (
      <div className={`modal-title-wrapper ${titleWrapperClassName}`}>
        <div className="modal-headline font-l palm-font-m">{title}</div>
      </div>
    ) : null}
    <div className={`modal-content-wrapper with-scroll-shadow ${contentClassName}`}>
      <div className="modal-content">
        {subTitle ? (
          <div id="subtitle">
            {subTitle}
            <br />
            <br />
          </div>
        ) : null}
        {children}
      </div>
    </div>
  </ReactModal>
);

Modal.defaultProps = {
  title: '',
  subTitle: '',
  afterOpenHandler: () => {},
  className: '',
  contentClassName: '',
  titleWrapperClassName: '',
};

Modal.propTypes = {
  opened: PropTypes.bool.isRequired,
  title: PropTypes.any,
  subTitle: PropTypes.string,
  closeHandler: PropTypes.func.isRequired,
  afterOpenHandler: PropTypes.func,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  titleWrapperClassName: PropTypes.string,
};

export default ModalWrapper(Modal);
